import { useIsMobile } from "@/hooks/use-mobile";
import { useNativePlatform } from "@/hooks/useNativePlatform";

/** Show page back nav on desktop web and on native (including phone). */
export function useShowNavigateBack(): boolean {
  const isMobile = useIsMobile();
  const { isNative } = useNativePlatform();
  return !isMobile || isNative;
}
